export default {
      id: "reports-usage",
      viewBox: "0 0 264.12 312.87",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#reports-usage",
      toString: function () {
        return this.url;
      }
    }